
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as aboutt7Ch_A6JVAPiITgZvIwB2JiOpOoK2t3UMU_45G2kxGl5AMeta } from "/app/monocle-gallery/pages/about.vue?macro=true";
import { default as indexM8UFSRlQYWzqs2K3_45hpJSRlPMA8vFp62SbxADTWczLwMeta } from "/app/monocle-gallery/pages/index.vue?macro=true";
import { default as learnYe6oHDD5RJ_45AVehZo6Yy_45qkf6osiFcKPSf_45Ad5XbQ_458Meta } from "/app/monocle-gallery/pages/learn.vue?macro=true";
import { default as logincEzvWMqfMI8FODVGwMceX_CSiXPmQBTlNpd7dTL4_B0Meta } from "/app/monocle-gallery/pages/login.vue?macro=true";
import { default as signinTnqc9YMZag74Lauz0jllCfxjWaAqDq_l0horN_Ow4_gMeta } from "/app/monocle-gallery/pages/signin.vue?macro=true";
import { default as accountsKhRcsfOPa5AggYF7mkawzbNm_45a9ofH__Kw_458icYBcQMeta } from "/app/monocle-gallery/pages/account.vue?macro=true";
import { default as contactLxlu_457Ff_3jlbezyROP_hX7hhqWIyDIib4zSqlHlEy4Meta } from "/app/monocle-gallery/pages/contact.vue?macro=true";
import { default as premium5KRqZAW6OmB_45ZKkvDT702QjXIJf4o2LhGLw04GgoTWwMeta } from "/app/monocle-gallery/pages/premium.vue?macro=true";
import { default as checkout8NGEqZfOngo_45DwloAoqI2Z2_YUHVnAcPNI9FoAXCqCMMeta } from "/app/monocle-gallery/pages/checkout.vue?macro=true";
import { default as registerYQVf8b3fEpVapPHeRbVcL3DtYyvHXXF1vBAhxRsGtGQMeta } from "/app/monocle-gallery/pages/register.vue?macro=true";
import { default as test_45pageUWZ4YmiRs1q1j_45eb_45JilqFYdGmc5q_45BczcFyjjjrmV8Meta } from "/app/monocle-gallery/pages/test-page.vue?macro=true";
import { default as app_45signin5bIGC_45QxdijYS1MT_GG2VVyb0mfkkpyEJi_gI_re3Q0Meta } from "/app/monocle-gallery/pages/app-signin.vue?macro=true";
import { default as indexREq4SnSoO5bbAxfHQAJMFvyTBmR4OeI_xm7CMs1ysDkMeta } from "/app/monocle-gallery/pages/blog/index.vue?macro=true";
import { default as indexfu3BYyV5D0QQW6bsCp6_gRYR_b1ZoWUY9kIyT7BttF8Meta } from "/app/monocle-gallery/pages/admin/index.vue?macro=true";
import { default as _91slug_93zAFo2zARHB6U10ZrpkaZKUG_TxJe04UkyL7XAQwOYzoMeta } from "/app/monocle-gallery/pages/blog/[slug].vue?macro=true";
import { default as mobile_45edithjKvCec2ldx0kqaYjwPReZ3WaotEVCgRsqwE21He7kIMeta } from "/app/monocle-gallery/pages/mobile-edit.vue?macro=true";
import { default as select_45plan1P054YvC_45Rj4jEqVEi5r0BFXXY1ot6WDun4s5VLAnOAMeta } from "/app/monocle-gallery/pages/select-plan.vue?macro=true";
import { default as email_45verifyN0ZDkZ780MQUmV9a7jIOZtbAk5o3k5IQ_45Jjb2JvODBMMeta } from "/app/monocle-gallery/pages/email-verify.vue?macro=true";
import { default as link_45account_45WPyu3JTwE60K23ETt1HiRZ8AVZ522WuWJqt003JrckMeta } from "/app/monocle-gallery/pages/link-account.vue?macro=true";
import { default as indextKL1XoidmP8_45yIkdZcEPuJzeyaUI7z4iukxrRysa6_QMeta } from "/app/monocle-gallery/pages/viewer/index.vue?macro=true";
import { default as confirm_45emailAYHT3h5qHlvlJAnDKjyabTqSVxQidWiZxxiwl4XIfLgMeta } from "/app/monocle-gallery/pages/confirm-email.vue?macro=true";
import { default as account_45deletepgPPZ0qVmiFBxJTUVUsMV2te6nZY1FNlSvp5kTSVrt4Meta } from "/app/monocle-gallery/pages/account-delete.vue?macro=true";
import { default as password_45resetLr9ng1cxldASs1KSZaU8TwoB8QUnGwrSQ1_45XwvOve0QMeta } from "/app/monocle-gallery/pages/password-reset.vue?macro=true";
import { default as update_45billingA6K9k22XLz4ujIRjEjkbp0GrLdn8fwa8njgQ7JlhGNYMeta } from "/app/monocle-gallery/pages/update-billing.vue?macro=true";
import { default as password_45changejQpJf5MibBIr4TdsltqoLlRP1pD8J4p_W_foXMRqYiEMeta } from "/app/monocle-gallery/pages/password-change.vue?macro=true";
import { default as _91id_93XV2ONdYl7qSmtcPabeUjqWozhN856B_nyUVCfkNLM_sMeta } from "/app/monocle-gallery/pages/admin/users/[id].vue?macro=true";
import { default as cancel_45subscription8CUIjAC9WZU_4_0bcyrvR_DJrXxxJ5_451iRuyrEhSvTYMeta } from "/app/monocle-gallery/pages/cancel-subscription.vue?macro=true";
import { default as password_45reset_45successZdjXHl0H98_456OjmY1mQryuIbZDAhTIsUToVyT4UIb5kMeta } from "/app/monocle-gallery/pages/password-reset-success.vue?macro=true";
import { default as request_45password_45resetEGIrWTTYRUYB0PKJSoAt61dHGZU7sjkAPP_M61lEzt8Meta } from "/app/monocle-gallery/pages/request-password-reset.vue?macro=true";
import { default as _91bundleId_93qNN1zuo0whMiyWGn8SPIEnIWHs_45TOdeWPxg5RyCPYtYMeta } from "/app/monocle-gallery/pages/admin/bundle/[bundleId].vue?macro=true";
import { default as monocle_45picker_45integrationjb2W5iPoYubxEWQhGjqwGS8bcoi2RMPaIa1Vzy_p2ccMeta } from "/app/monocle-gallery/pages/partner/monocle-picker-integration.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/app/monocle-gallery/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexM8UFSRlQYWzqs2K3_45hpJSRlPMA8vFp62SbxADTWczLwMeta || {}), ...{"middleware":["loggedin","gallery-legacy"]} },
    component: () => import("/app/monocle-gallery/pages/index.vue"),
    children: [
  {
    path: "models",
    name: "gallery-models"
  },
  {
    path: "models/:bundleId",
    name: "gallery-model"
  },
  {
    path: "collections",
    name: "gallery-collections"
  },
  {
    path: "collections/:collectionId",
    name: "gallery-collection"
  },
  {
    path: "collections/:collectionId/settings",
    name: "gallery-collection-settings"
  },
  {
    path: "collections/:collectionId/models/:bundleId",
    name: "gallery-collection-model"
  }
]
  },
  {
    name: "learn",
    path: "/learn",
    component: () => import("/app/monocle-gallery/pages/learn.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: logincEzvWMqfMI8FODVGwMceX_CSiXPmQBTlNpd7dTL4_B0Meta || {},
    component: () => import("/app/monocle-gallery/pages/login.vue")
  },
  {
    name: "signin",
    path: "/signin",
    meta: signinTnqc9YMZag74Lauz0jllCfxjWaAqDq_l0horN_Ow4_gMeta || {},
    component: () => import("/app/monocle-gallery/pages/signin.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: {"middleware":["loggedin"]},
    component: () => import("/app/monocle-gallery/pages/account.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/app/monocle-gallery/pages/contact.vue")
  },
  {
    name: "premium",
    path: "/premium",
    component: () => import("/app/monocle-gallery/pages/premium.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: { ...(checkout8NGEqZfOngo_45DwloAoqI2Z2_YUHVnAcPNI9FoAXCqCMMeta || {}), ...{"middleware":["verified"]} },
    component: () => import("/app/monocle-gallery/pages/checkout.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: { ...(registerYQVf8b3fEpVapPHeRbVcL3DtYyvHXXF1vBAhxRsGtGQMeta || {}), ...{"middleware":["loggedout"]} },
    component: () => import("/app/monocle-gallery/pages/register.vue")
  },
  {
    name: "test-page",
    path: "/test-page",
    component: () => import("/app/monocle-gallery/pages/test-page.vue")
  },
  {
    name: "app-signin",
    path: "/app-signin",
    component: () => import("/app/monocle-gallery/pages/app-signin.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/app/monocle-gallery/pages/blog/index.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/app/monocle-gallery/pages/admin/index.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/app/monocle-gallery/pages/blog/[slug].vue")
  },
  {
    name: "mobile-edit",
    path: "/mobile-edit",
    component: () => import("/app/monocle-gallery/pages/mobile-edit.vue")
  },
  {
    name: "select-plan",
    path: "/select-plan",
    meta: {"middleware":["verified"]},
    component: () => import("/app/monocle-gallery/pages/select-plan.vue")
  },
  {
    name: "email-verify",
    path: "/email-verify",
    meta: email_45verifyN0ZDkZ780MQUmV9a7jIOZtbAk5o3k5IQ_45Jjb2JvODBMMeta || {},
    component: () => import("/app/monocle-gallery/pages/email-verify.vue")
  },
  {
    name: "link-account",
    path: "/link-account",
    component: () => import("/app/monocle-gallery/pages/link-account.vue")
  },
  {
    name: "viewer",
    path: "/viewer",
    meta: indextKL1XoidmP8_45yIkdZcEPuJzeyaUI7z4iukxrRysa6_QMeta || {},
    component: () => import("/app/monocle-gallery/pages/viewer/index.vue")
  },
  {
    name: "confirm-email",
    path: "/confirm-email",
    component: () => import("/app/monocle-gallery/pages/confirm-email.vue")
  },
  {
    name: "account-delete",
    path: "/account-delete",
    component: () => import("/app/monocle-gallery/pages/account-delete.vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: password_45resetLr9ng1cxldASs1KSZaU8TwoB8QUnGwrSQ1_45XwvOve0QMeta || {},
    component: () => import("/app/monocle-gallery/pages/password-reset.vue")
  },
  {
    name: "update-billing",
    path: "/update-billing",
    component: () => import("/app/monocle-gallery/pages/update-billing.vue")
  },
  {
    name: "password-change",
    path: "/password-change",
    component: () => import("/app/monocle-gallery/pages/password-change.vue")
  },
  {
    name: "admin-users-id",
    path: "/admin/users/:id()",
    component: () => import("/app/monocle-gallery/pages/admin/users/[id].vue")
  },
  {
    name: "cancel-subscription",
    path: "/cancel-subscription",
    component: () => import("/app/monocle-gallery/pages/cancel-subscription.vue")
  },
  {
    name: "password-reset-success",
    path: "/password-reset-success",
    meta: password_45reset_45successZdjXHl0H98_456OjmY1mQryuIbZDAhTIsUToVyT4UIb5kMeta || {},
    component: () => import("/app/monocle-gallery/pages/password-reset-success.vue")
  },
  {
    name: "request-password-reset",
    path: "/request-password-reset",
    meta: request_45password_45resetEGIrWTTYRUYB0PKJSoAt61dHGZU7sjkAPP_M61lEzt8Meta || {},
    component: () => import("/app/monocle-gallery/pages/request-password-reset.vue")
  },
  {
    name: "admin-bundle-bundleId",
    path: "/admin/bundle/:bundleId()",
    component: () => import("/app/monocle-gallery/pages/admin/bundle/[bundleId].vue")
  },
  {
    name: "partner-monocle-picker-integration",
    path: "/partner/monocle-picker-integration",
    meta: {"middleware":["loggedin"]},
    component: () => import("/app/monocle-gallery/pages/partner/monocle-picker-integration.vue")
  }
]